import { useState } from "react";
import PageHeader from "@/components/PageHeader";
import CoursesTab from "@/components/catalog/CoursesTab";
import CategoriesTab from "@/components/catalog/CategoriesTab";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

export default function Courses() {
  const [refreshKey, setRefreshKey] = useState(0);

  return (
    <div data-testid="courses-page">
      <PageHeader title="Courses" subtitle="Manage your training catalogue and categories." />
      <Tabs defaultValue="courses">
        <TabsList className="mb-6">
          <TabsTrigger value="courses" data-testid="tab-courses">Courses</TabsTrigger>
          <TabsTrigger value="categories" data-testid="tab-categories">Categories</TabsTrigger>
        </TabsList>
        <TabsContent value="courses"><CoursesTab refreshKey={refreshKey} /></TabsContent>
        <TabsContent value="categories"><CategoriesTab onChange={() => setRefreshKey((k) => k + 1)} /></TabsContent>
      </Tabs>
    </div>
  );
}
